// For n-ary tree with in branch array 'children' and elements to check in an
// array 'containerArray' stored in the node
// e.g. nodes like this
// {
//   files: [file1,file2,...],
//   children: [branchnode1, branchnode2, branchnode3,....]
// }
// tree is pointer to a node
// children = 'children'
// containerArray = 'files'
// filter is a function takes a node object and interrogates it in some way

// Unit test status: TESTED
function findFirstTreeNode(tree, children, containerArray, filter) {
    let found = false;

    if (tree[containerArray]) {
        //    if (Array.isArray(tree[containerArray]))
        //      found = tree[containerArray].find(tce => filter(tce))
        //    else
        found = filter(tree) ? tree : false;
    }

    if (!found) {
        if (tree[children]) {
            tree[children].some((tc) => {
                const result = findFirstTreeNode(tc, children, containerArray, filter);
                if (result) found = result;
                return result;
            });
        }
    }
    return found;
}
// Top down filter for an n-ary tree, parent nodes prioritised over children
// A copy of the tree is returned
// if a filter function returns false on a node, the walk is stopped below that node
// Unit test status: TESTED
function filterTree(tree, filter, children = 'children', newtree = null) {
    if (!filter || !tree) return tree;
    if (filter(tree) || findFirstTreeNode(tree, 'children', 'visible', node => node.visible)) {
        const nn = { ...tree };
        delete nn[children];
        if (newtree) {
            // eslint-disable-next-line no-param-reassign
            if (!newtree[children]) newtree[children] = [];
            // eslint-disable-next-line no-param-reassign
            newtree[children].push(nn);
        } else {
            // eslint-disable-next-line no-param-reassign
            newtree = nn;
        }
        if (tree[children] && Array.isArray(tree[children])) {
            tree[children].forEach(ntree => filterTree(ntree, filter, children, nn));
        }
    }
    return newtree;
}

function flattenTreeField(tree, field, children, accum) {
    accum.push(tree[field]);

    if (tree[children] && Array.isArray(tree[children])) {
        tree[children].forEach(ntree => flattenTreeField(ntree, field, children, accum));
    }
    return accum;
}

// Return a flat array of field values for nodes that pass test filter
function flattenFilteredTreeField(
    tree,
    field,
    filter = node => true,
    children = 'children',
    accum = []
) {
    if (!field || !tree) return tree;

    if (filter(tree)) accum.push(tree[field]);

    if (tree[children] && Array.isArray(tree[children])) {
        tree[children].forEach(ntree =>
            flattenFilteredTreeField(ntree, field, filter, children, accum)
        );
    }
    return accum;
}

// Return a flat array of field values for nodes that pass test filter
// filter looks at both the current node and it's parent
function flattenParentFilteredTreeField(
    tree,
    field,
    filter = (node, parent) => true,
    children = 'children',
    accum = [],
    parent = null
) {
    if (!field || !tree) return tree;
    if (filter(tree, parent)) accum.push(tree[field]);

    if (tree[children] && Array.isArray(tree[children])) {
        tree[children].forEach(ntree =>
            flattenParentFilteredTreeField(ntree, field, filter,
                children, accum, tree)
        );
    }
    return accum;
}

function transformTreeNodes(tree, children, transform) {
    transform(tree);

    if (tree[children] && Array.isArray(tree[children])) {
        tree[children].forEach(ntree => transformTreeNodes(ntree, children, transform));
    }
}

function arrayTreeField(tree, field, children, accum, cat = null) {
    if (cat) cat.push(tree[field]);
    else cat = tree[field] ? [tree[field]] : []; // eslint-disable-line no-param-reassign

    if (tree[children] && tree[children].length && Array.isArray(tree[children])) {
        tree[children].forEach((ntree) => {
            arrayTreeField(ntree, field, children, accum, cat.slice());
        });
    } else {
        accum.push(cat);
    }
    return accum;
}

export default {
    transformTreeNodes,
    filterTree,
    findFirstTreeNode,
    flattenFilteredTreeField,
    flattenParentFilteredTreeField,
    flattenTreeField,
    arrayTreeField
};



// WEBPACK FOOTER //
// ./src/lib/treeutils.js